import './styles.css'

import { HStack, IconButton, Image, Text, VStack } from '@chakra-ui/react'
import { ChevronRightIcon } from '@editor/assets/icons'
import LoadingAnimation from '@editor/assets/imgs/loading-animation-black.gif'
import { PanelType } from '@editor/config/constants'
import { INFO_PANEL_WIDTH } from '@editor/config/styles'
import { EditorConfig } from '@editor/interfaces/editor'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { setCollapsedPanel } from '../../store/blueprintEditor'
import ToolsPanel from '../ToolsPanel'
import ElementsPanel from './components/ElementsPanel'
import SettingsPanel from './components/SettingsPanel'
import StylesPanel from './components/StylesPanel'

interface InfoPanelProps {
  toolsConfig: (
    | {
        key: string
        auth: boolean
        hook: EditorConfig
      }
    | undefined
  )[]
}

const InfoPanels = ({ toolsConfig }: InfoPanelProps) => {
  // Store
  const dispatch = useAppDispatch()
  const collapsedPanel = useSelector((state: RootState) => state.blueprint.editor.collapsedPanel)
  const solidMeshProgress = useSelector((state: RootState) => state.solidMesh.progress)

  return (
    <HStack h="100%" id="panel-container" zIndex={10}>
      {solidMeshProgress !== undefined && (
        <HStack bgColor="black" borderColor="gray2.800" borderWidth="1px" px={2} height="32px" borderRadius="md">
          <Image src={LoadingAnimation} h="28px" />
          <Text>3Dメッシュデータ読み込み中... </Text>
          <Text w="36px" textAlign="right">
            {Math.round(solidMeshProgress * 100)}%
          </Text>
        </HStack>
      )}
      <IconButton
        bg="gray2.900"
        color="white"
        borderRadius="md"
        aria-label=""
        size="sm"
        className={['collapse-all-panel', collapsedPanel.length !== 3 ? '' : 'collapsed'].join(' ')}
        _hover={{ bg: 'gray2.700' }}
        onClick={() =>
          dispatch(
            setCollapsedPanel(
              collapsedPanel.length !== 3 ? [PanelType.Settings, PanelType.Elements, PanelType.Tool] : [],
            ),
          )
        }
      >
        <ChevronRightIcon width="1.5rem" height="1.5rem" />
      </IconButton>
      <VStack width={INFO_PANEL_WIDTH} h="100%">
        <SettingsPanel />

        <ElementsPanel />

        <StylesPanel />

        <ToolsPanel toolsConfig={toolsConfig} />
      </VStack>
    </HStack>
  )
}

export default InfoPanels
